"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _shared = require("choerodon-ui/shared");
var _button = _interopRequireDefault(require("../button"));
var _LocaleReceiver = _interopRequireDefault(require("../locale-provider/LocaleReceiver"));
var _locale = require("./locale");
var _dialog = _interopRequireDefault(require("../rc-components/dialog"));
var _ConfigContext = _interopRequireDefault(require("../config-provider/ConfigContext"));
var Modal = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Modal, _Component);
  var _super = (0, _createSuper2["default"])(Modal);
  function Modal() {
    var _this;
    (0, _classCallCheck2["default"])(this, Modal);
    _this = _super.apply(this, arguments);
    _this.handleCancel = function (e) {
      var onCancel = _this.props.onCancel;
      if (onCancel) {
        onCancel(e);
      }
    };
    _this.handleOk = function (e) {
      var onOk = _this.props.onOk;
      if (onOk) {
        onOk(e);
      }
    };
    _this.renderFooter = function (locale) {
      var _this$props = _this.props,
        okText = _this$props.okText,
        okType = _this$props.okType,
        cancelText = _this$props.cancelText,
        confirmLoading = _this$props.confirmLoading,
        funcType = _this$props.funcType,
        disableOk = _this$props.disableOk,
        disableCancel = _this$props.disableCancel,
        cancelButtonProps = _this$props.cancelButtonProps,
        okButtonProps = _this$props.okButtonProps;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
        disabled: disableCancel || confirmLoading,
        onClick: _this.handleCancel,
        funcType: funcType
      }, cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
        type: okType,
        funcType: funcType,
        disabled: disableOk,
        loading: confirmLoading,
        onClick: _this.handleOk
      }, okButtonProps), okText || locale.okText));
    };
    return _this;
  }
  (0, _createClass2["default"])(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _shared.ModalManager.registerMousePosition();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$context = this.context,
        getPrefixCls = _this$context.getPrefixCls,
        getConfig = _this$context.getConfig;
      var _this$props2 = this.props,
        footer = _this$props2.footer,
        visible = _this$props2.visible,
        customizePrefixCls = _this$props2.prefixCls,
        _this$props2$movable = _this$props2.movable,
        movable = _this$props2$movable === void 0 ? getConfig('modalMovable') : _this$props2$movable,
        _this$props2$center = _this$props2.center,
        center = _this$props2$center === void 0 ? getConfig('modalAutoCenter') : _this$props2$center,
        _this$props2$maskClos = _this$props2.maskClosable,
        maskClosable = _this$props2$maskClos === void 0 ? getConfig('modalMaskClosable') : _this$props2$maskClos,
        _this$props2$keyboard = _this$props2.keyboard,
        keyboard = _this$props2$keyboard === void 0 ? getConfig('modalKeyboard') : _this$props2$keyboard;
      var prefixCls = getPrefixCls('modal', customizePrefixCls);
      var defaultFooter = /*#__PURE__*/_react["default"].createElement(_LocaleReceiver["default"], {
        componentName: "Modal",
        defaultLocale: (0, _locale.getConfirmLocale)()
      }, this.renderFooter);
      return /*#__PURE__*/_react["default"].createElement(_dialog["default"], (0, _extends2["default"])({}, this.props, {
        movable: movable,
        maskClosable: maskClosable,
        center: center,
        keyboard: keyboard,
        prefixCls: prefixCls,
        footer: footer === undefined ? defaultFooter : footer,
        visible: visible,
        mousePosition: _shared.ModalManager.mousePosition,
        onClose: this.handleCancel
      }));
    }
  }], [{
    key: "contextType",
    get: function get() {
      return _ConfigContext["default"];
    }
  }]);
  return Modal;
}(_react.Component);
exports["default"] = Modal;
Modal.displayName = 'Modal';
Modal.defaultProps = {
  width: 520,
  transitionName: 'zoom',
  maskTransitionName: 'fade',
  confirmLoading: false,
  disableOk: false,
  disableCancel: false,
  visible: false,
  okType: 'primary',
  okButtonDisabled: false,
  cancelButtonDisabled: false,
  center: false
};